import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import Title from '../Title';
import NextLink from '../NextLink';
import TitledBlock from '../TitledBlock';

const useStyles = makeStyles(theme => ({
  root: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline',
    },
  },
}));

const TitledLink = ({ className, linkText, title, titleSize, titleColor, linkProps }) => {
  const classes = useStyles();
  return (
    <TitledBlock title={title} titleSize={titleSize} titleColor={titleColor} className={cn(classes.root, className)}>
      {linkProps ? (
        <NextLink {...linkProps}>
          <span>{linkText}</span>
        </NextLink>
      ) : (
        <div>{linkText}</div>
      )}
    </TitledBlock>
  );
};

TitledLink.propTypes = {
  titleSize: Title.propTypes.size,
  className: PropTypes.string,
  title: PropTypes.string,
  linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
  linkText: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
};

TitledLink.defaultProps = {
  titleSize: 'small',
};

export default TitledLink;
